/* ============================================================
   dr.GUT — Fechar o filtro clicando fora

   O tema desenha a cortina escura como ::after do próprio botão de filtro e
   conta com o clique nela para fechar. Só que o evento não chega ao botão:
   o alvo do clique é o <main> que está atrás, então a cortina é decorativa —
   dá para clicar nos produtos por baixo dela e o filtro nunca fecha.

   Aqui o clique é interceptado na fase de captura: se ele cair fora do painel,
   fecha o filtro e para por ali, sem acionar o link que estava embaixo.
   ============================================================ */
(function () {
  var raiz = document.documentElement;

  function painel() {
    return document.getElementById('CollectionSidebar');
  }

  function aberto() {
    var p = painel();
    return !!p && p.classList.contains('open');
  }

  function fechar() {
    var p = painel();
    if (!p) return;
    p.classList.remove('open');
    raiz.classList.remove('open-drawer', 'open-sidebar');
    raiz.style.removeProperty('padding-right');
    /* o botão guarda o próprio estado: sem limpar, o próximo clique nele
       entenderia que ainda está aberto e não abriria nada */
    var botoes = document.querySelectorAll('btn-filter.open');
    for (var i = 0; i < botoes.length; i++) botoes[i].classList.remove('open');
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!aberto()) return;
      var alvo = e.target;
      if (!alvo || !alvo.closest) return;
      if (painel().contains(alvo)) return;
      /* no próprio botão quem manda é o toggle do tema */
      if (alvo.closest('btn-filter')) return;

      e.preventDefault();
      e.stopPropagation();
      fechar();
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && aberto()) fechar();
  });
})();
